<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="categoryDescription"
        >
          <span class="fs-3"
            >{{ 'general.categoryDescription' | translate }}
            <span *ngIf="siteId !== null"> ( Site: {{ siteId }} ) </span></span
          >

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>
    <div *ngIf="!isCollapsed" class="card-body" id="categoryDescription">
      <!-- No category & explanation -->
      <fieldset class="mb-4">
        <legend class="form-label" id="catNoCat{{ siteId }}"
          >{{ 'general.noCategory' | translate }}
        </legend>
        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-nl"
                  id="flag-nl-{{ siteId }}-1"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCat{{ siteId }} flag-nl-{{
                  siteId
                }}-1"
                formControlName="nl_category0desc"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-en"
                  id="flag-en-{{ siteId }}-1"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCat{{ siteId }} flag-en-{{
                  siteId
                }}-1"
                formControlName="en_category0desc"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  id="flag-fr-{{ siteId }}-1"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCat{{ siteId }} flag-fr-{{
                  siteId
                }}-1"
                formControlName="fr_category0desc"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  id="flag-de-{{ siteId }}-1"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCat{{ siteId }} flag-de-{{
                  siteId
                }}-1"
                formControlName="de_category0desc"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="mb-4">
        <legend class="form-label" id="catNoCatExpl{{ siteId }}">
          {{ 'general.noCategory' | translate }}
          {{ 'general.explanation' | translate | lowercase }}
        </legend>
        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-nl"
                  id="flag-nl-{{ siteId }}-2"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCatExpl{{ siteId }} flag-nl-{{
                  siteId
                }}-2"
                formControlName="nl_category0_explanation"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-en"
                  id="flag-en-{{ siteId }}-2"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCatExpl{{ siteId }} flag-en-{{
                  siteId
                }}-2"
                formControlName="en_category0_explanation"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-fr"
                  id="flag-fr-{{ siteId }}-2"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCatExpl{{ siteId }} flag-fr-{{
                  siteId
                }}-2"
                formControlName="fr_category0_explanation"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  role="img"
                  class="flag flag-de"
                  id="flag-de-{{ siteId }}-2"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                attr.aria-labelledby="catNoCatExpl{{ siteId }} flag-de-{{
                  siteId
                }}-2"
                formControlName="de_category0_explanation"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <!-- End no category & explanation-->

      <div *ngFor="let category of [1, 2, 3, 4, 5, 6, 7, 8, 9]; let i = index">
        <!-- general category-->
        <fieldset class="mb-4">
          <legend class="form-label" id="catCat{{ siteId }}-{{ i }}"
            >{{ 'general.category' | translate }} {{ i + 1 }}
          </legend>
          <div class="row g-2">
            <div class="col-lg-6" *ngIf="availableLanguages['nl']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-nl"
                    id="flag-nl-a{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCat{{ siteId }}-{{ i }} flag-nl-a{{
                    siteId
                  }}-{{ i }}"
                  formControlName="{{ 'nl_category' + category + 'desc' }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['en']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-en"
                    id="flag-en-a{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCat{{ siteId }}-{{ i }} flag-en-a{{
                    siteId
                  }}-{{ i }}"
                  formControlName="{{ 'en_category' + category + 'desc' }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['fr']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-fr"
                    id="flag-fr-a{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCat{{ siteId }}-{{ i }} flag-fr-a{{
                    siteId
                  }}-{{ i }}"
                  formControlName="{{ 'fr_category' + category + 'desc' }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['de']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    id="flag-de-a{{ siteId }}-{{ i }}"
                    class="flag flag-de"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCat{{ siteId }}-{{ i }} flag-de-a{{
                    siteId
                  }}-{{ i }}"
                  formControlName="{{ 'de_category' + category + 'desc' }}"
                />
              </div>
            </div>
          </div>
        </fieldset>
        <!-- END general category-->

        <!-- Cateogory Explanation-->
        <fieldset class="mb-4">
          <legend class="form-label" id="catCatExpl{{ siteId }}-{{ i }}">
            {{ 'general.category' | translate }} {{ i + 1 }}
            {{ 'general.explanation' | translate | lowercase }}
          </legend>
          <div class="row g-2">
            <div class="col-lg-6" *ngIf="availableLanguages['nl']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-nl"
                    id="flag-nl-b{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCatExpl{{ siteId }}-{{
                    i
                  }} flag-nl-b{{ siteId }}-{{ i }}"
                  formControlName="{{
                    'nl_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['en']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-en"
                    id="flag-en-b{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCatExpl{{ siteId }}-{{
                    i
                  }} flag-en-b{{ siteId }}-{{ i }}"
                  formControlName="{{
                    'en_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['fr']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-fr"
                    id="flag-fr-b{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span
                ></span>
                <input
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCatExpl{{ siteId }}-{{
                    i
                  }} flag-fr-b{{ siteId }}-{{ i }}"
                  formControlName="{{
                    'fr_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
            <div class="col-lg-6" *ngIf="availableLanguages['de']">
              <div class="input-group">
                <span class="input-group-text"
                  ><span
                    role="img"
                    class="flag flag-de"
                    id="flag-de-b{{ siteId }}-{{ i }}"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span
                ></span>
                <input
                  [canEdit]="[accessRights.Settings_write]"
                  [canEdit]="[accessRights.ConfigurationOptions_write]"
                  type="text"
                  class="form-control"
                  attr.aria-labelledby="catCatExpl{{ siteId }}-{{
                    i
                  }} flag-de-b{{ siteId }}-{{ i }}"
                  formControlName="{{
                    'de_category' + category + '_explanation'
                  }}"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
